export function cn(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ');
}

export const SITE_URL = ((import.meta.env.VITE_PUBLIC_SITE_URL as string | undefined) || window.location.origin).replace(/\/$/, '');
export const TURNSTILE_SITE_KEY = (import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined) || '';

const dateFmt = new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
const dateTimeFmt = new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });

export function formatDate(value: string | Date | null | undefined): string {
  return value ? dateFmt.format(new Date(value)) : '—';
}

export function formatDateTime(value: string | Date | null | undefined): string {
  return value ? dateTimeFmt.format(new Date(value)) : '—';
}

export function formatMoney(amount: string | null, currency: string | null): string {
  if (!amount || !currency) return '—';
  try {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(Number(amount));
  } catch {
    return `${amount} ${currency}`;
  }
}

export function whatsappLink(number: string, text?: string): string {
  const base = `https://wa.me/${number}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}

/** Splits `text` around the first occurrence of `word` for highlighted rendering. */
export function splitHighlight(text: string, word: string): [string, string, string] {
  const i = word ? text.indexOf(word) : -1;
  if (i < 0) return [text, '', ''];
  return [text.slice(0, i), word, text.slice(i + word.length)];
}

/** Converts an ISO date string to the value format of <input type="datetime-local"> in local time. */
export function toLocalInputValue(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Removes repeated phone numbers (compared by digits) so the same number isn't listed twice. */
export function uniquePhones<T extends { number: string }>(phones: T[]): T[] {
  const seen = new Set<string>();
  return phones.filter((p) => {
    const key = p.number.replace(/\D/g, '');
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
